var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFeedMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1032 9.7745C18.1061 10.8963 17.844 12.003 17.3383 13.0043C16.7386 14.2042 15.8166 15.2135 14.6757 15.919C13.5349 16.6246 12.2201 16.9986 10.8786 16.9991C9.7568 17.002 8.65015 16.7399 7.64881 16.2341L2.80408 17.849L4.41899 13.0043C3.91321 12.003 3.6511 10.8963 3.65403 9.7745C3.65455 8.43307 4.02853 7.11827 4.73408 5.97738C5.43963 4.83649 6.44889 3.91456 7.64881 3.31486C8.65015 2.80908 9.7568 2.54698 10.8786 2.54991H11.3036C13.0752 2.64764 14.7485 3.3954 16.0031 4.65002C17.2577 5.90463 18.0055 7.57793 18.1032 9.34952V9.7745Z",
    stroke: "#767676",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFeedMessage);
export default __webpack_public_path__ + "static/media/icon-feed-message.20371b4af17a04e88eeab5578f5fcfc1.svg";
export { ForwardRef as ReactComponent };